module.exports = __webpack_public_path__ + "static/media/office-break.1d44cf0f.jpg";